<template>
  <span class="audio">
    <!-- <div class="audio__button">
      <transition name="fade">
        <a @click="play" v-if="playing === false" key="play"><img :src="'../static/image/bgm_on.png'" alt=""></a>
        <a @click="stop" v-else><img :src="'../static/image/bgm_off.png'" alt=""></a>
      </transition>
    </div> -->
    <a class="sound"  @click="!soundMute ? stop() : play()" v-show="bgm"><!--SOUND--><img src="../assets/image/txt_sound.png" alt="sound"><img v-show="!soundMute" src="../assets/image/icn_sound_on.png" alt=""><img v-show="soundMute" src="../assets/image/icn_sound_off.png" alt=""></a>
    <audio :src="'./static/sound/' + listSound[file]" preload="auto" @ended="onEndAudio(redirect)"></audio>
  </span>
</template>

<script>
//  import _ from 'lodash'
  import { store } from '../store/store'
  export default{
    name: 'vue-audio',
    props: {
      file: Number,
      redirect: String,
      bgm: Boolean,
      loop: Boolean
    },
    data () {
      return {
        isMuted: false,
        loaded: false,
        playing: false,
        paused: false,
        audio: undefined,
        timeupdate: 0
      }
    },
    computed: {
      soundMute () {
        return store.state.soundMute
      },
      currentScreen () {
        return store.state.currentScreen
      },
      listSound () {
        return store.state.soundList
      }
    },
    methods: {
      play () {
        if (this.playing) return
        this.paused = false
        this.audio.play()
        this.audio.muted = this.bgm ? false : this.soundMute
        // Change audio volume
        // 最初のカードを選ぶSE / サイコロを振っているところSEの音量を変わる
        if (this.file === 4 || this.file === 7) {
          this.audio.volume = 0.2
        }
        this.playing = true
        this.audio.currentTime = 0
        if (this.bgm) {
          store.dispatch('setSoundMute', false)
        }
      },
      stop () {
        this.paused = this.playing = false
        if (this.bgm) {
          store.dispatch('setSoundMute', true)
          this.audio.muted = true
        } else {
          this.audio.pause()
        }
      },
      onEndAudio () {
        // console.log('ended')
        this.paused = this.playing = false
        this.audio.pause()
        this.audio.currentTime = 0
        if (this.redirect !== '' && this.redirect !== undefined) {
          store.dispatch('setCurrentScreen', this.redirect)
        }
      }
    },
    mounted: function () {
      this.audio = this.$el.querySelectorAll('audio')[0]
      if (this.loop) {
        this.audio.loop = true
      }
    },
    watch: {
      currentScreen (v) {
        if (this.bgm && !this.soundMute) {
          this.audio.oncanplay = function () {
            if (v === 'result') {
              setTimeout(() => { this.play() }, 2000)
            } else {
              this.play()
            }
            // this.playing = true
            // console.log('-------------AUTO PLAY ---------------')
            // this.audio.muted = this.soundMute
          }
        }
      },
      soundMute (k) {
        // this.isMuted = this.soundMute
        // console.log(this.file + '--------' + this.playing + '----------' + !this.audio.paused)
        if (!this.audio.paused) {
          this.audio.muted = k
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  // .audio__button {
  //   position: relative;
  //   margin: 0 auto;
  //   display: block;
  //   width: 65px;
  //   height: 65px;
  // }

  // .audio__button a {
  //   position: absolute;
  // }

  // .fade-enter-active, .fade-leave-active {
  //   transition: opacity .2s;
  // }

  // .fade-enter, .fade-leave-active {
  //   opacity: 0;
  // }

</style>



// WEBPACK FOOTER //
// Audio.vue?0224e3c8